<template>
  <div class="headercom">
    <div class="header-log">
      <img src="static/image/hengan_logo@3x.png" />
    </div>
    <div class="header-setting">
      <img src="static/image/header-bell.png" height="100%" @click="msgList" />
      <!-- <img src="static/image/header-bell.png" height="100%" /> -->
      <span class="msgdot" v-show="reddot"></span>
    </div>
    <div class="header-bell">
      <img @click="dialogVisible = logOut" src="static/image/header-setting.png" height="100%" />
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible"  :append-to-body=true width="30%">
      <span>退出登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notLogOut()">取 消</el-button>
        <el-button type="primary" @click="logOut()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入api模块
import api from '@/modules/api'
export default {
  //        组件名称
  name: 'Header',
  //        初始化数据
  data () {
    return {
      dialogVisible: false,
      reddot: false// header铃铛上面的红点
    }
  },
  //        方法集
  methods: {
    // 登出
    notLogOut () {
      this.dialogVisible = false
      this.$message({
        type: 'info',
        message: '取消退出'
      })
    },
    logOut () {
      window.sessionStorage.removeItem('sidebar_active');
      this.delCookie('jtl')
      this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
      window.location.href = this.$logOutFront + encodeURIComponent('https://sso.ihasl.com/logout?service=' + encodeURIComponent(this.homePage + this.$address))
    },
    getCookie (key) {
      var arr, reg = RegExp('(^| )' + key + '=([^;]+)(;|$)')
      if (arr = document.cookie.match(reg)) // ["username=liuwei;", "", "liuwei", ";"]
      { return decodeURIComponent(arr[2]) } else { return null }
    },
    delCookie (key) {
      var date = new Date()
      date.setTime(date.getTime() - 1)
      var delValue = this.getCookie(key)
      if (delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString()
      }
    },
    msgList(){
      this.$router.push({name: 'msgList',query:{msgType:'0'}})
    },
    getIsread(){
      let that = this
      api.post(that.$url.getAllType,{},(res)=> {
        console.log(res,'所有数据')
        if(res.result.isSuccess){
          // that.result = res.data
          // console.log(that.result,'data数据')
          let haveNew = res.data.typeMessages.find((item)=>{
            return item.haveNew
          })
          if(haveNew){
            that.reddot = true
          }else{
            that.reddot = false
          }
        }
      })
    }
  },
  //        进入加载
  created () {},
  mounted(){
    this.getIsread()
  }
}
</script>
<style scoped>
.headercom {
  background-color: #194793;
  height: 60px;
  line-height: 60px;
  /* position:fixed; */
  top:0;
  right:0;
  width: 100%;
  /* padding-left:7%; */
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  z-index: 1005;
}
.header-log {
  float: left;
  height:100%;
  margin-left: 40%;
}
.header-log img{ height:70%;margin-top:5%;}
.header-setting {
  float: right;
  margin-right: 4%;
  /* margin-top: 25px;
  height: 35%; */
  margin-top:5px;
  height:25px;
  position: relative;
  cursor: pointer;
}
.msgdot{ display: block; width: 8px; height: 8px; border-radius:50%; background:red; position: absolute; top:7px; right:0;}
.header-bell {
  float: right;
  /* margin-right: 5%; */
  margin-right: 30px;
  /* margin-top: 25px;
  height: 35%; */
  margin-top:7px;
  height:28px;
  cursor: pointer;
}
.topcon{
  width:100%;
  position: relative;
  color: #fff;
  text-align: center;
  font-size:18px;
  font-weight: 600;
  margin-left:-14px;
}
/* 头部返回箭头样式 */
.backIcon{
  font-size:30px;
  height: 50px;
  line-height: 50px !important;
  cursor: pointer;
  position: absolute;
  left:10px;
  color:#fff;
}
.header_right{
  height: 100%;
  position: absolute;
  width: 150px;
  right:20px;
  top: 0;
  /* line-height:normal; */
}
/* .botborder{width:98%; margin:0 auto;border-bottom: 1px solid #DFDFDF;} */
@media screen and (max-width: 1024px){
  .headercom{
    height:50px;
    line-height: 50px;
  }
  /* .menu{padding-top: 50px;} */
  /* .conH{ height:50px;} */
}

</style>



// WEBPACK FOOTER //
// src/layout/Header.vue